module.exports = __webpack_public_path__ + "static/BuenosAiresWeb-Bold-6f2455018b33a2cb7a71c40854070641.woff";